import React from "react";
import RootlyIcon from "src/components/ui/icons/rootly";
import TierZeroMark from "src/components/ui/icons/tierzero_mark";
import { useMe } from "src/context/MeContext";
import { isSlackManagedByRootly } from "src/utils/brandTheme";

// Pure presentational avatar component for chat bubbles
// Shows Rootly icon for ROOTLY/ROOTLY_COBRAND orgs, TierZero mark otherwise
interface TierZeroAvatarProps {
  brandTheme?: string | null;
}

export const TierZeroAvatar: React.FC<TierZeroAvatarProps> = ({ brandTheme }) => {
  const showRootlyIcon = isSlackManagedByRootly(brandTheme);

  if (showRootlyIcon) {
    return (
      <div className="flex items-center justify-center w-full h-full bg-[#8567f7] rounded-lg">
        <RootlyIcon className="w-5 h-5 !bg-transparent !p-0 !rounded-none brightness-0 invert" />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center w-full h-full rounded-lg bg-gradient-to-br from-gray-800 to-black dark:from-white dark:to-gray-200">
      <TierZeroMark className="w-5 h-5 text-white dark:text-black" />
    </div>
  );
};

// Wrapper that uses MeContext - use this in components within MeProvider
export const TierZeroAvatarWithMe: React.FC = () => {
  const me = useMe();
  const brandTheme = me.organization?.brandTheme;
  return <TierZeroAvatar brandTheme={brandTheme} />;
};

export default TierZeroAvatarWithMe;